import { render, staticRenderFns } from "./InspectionStatusDetail.vue?vue&type=template&id=957f1c1c&scoped=true&"
import script from "./InspectionStatusDetail.vue?vue&type=script&lang=js&"
export * from "./InspectionStatusDetail.vue?vue&type=script&lang=js&"
import style0 from "./InspectionStatusDetail.vue?vue&type=style&index=0&id=957f1c1c&lang=scss&scoped=true&"
import style1 from "./InspectionStatusDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957f1c1c",
  null
  
)

export default component.exports